import React, { Component } from "react";
import Page from "../../components/Page";

class Grondbeleid extends Component {
  render() {
    return (
      <Page title="Grondbeleid">
        <p>
          <img
            alt="Grondbeleid"
            src={process.env.PUBLIC_URL + "/images/themas/grondbeleid.jpg"}
            className="fullwidth shadow"
          />
        </p>

        <p>
          Het Beverhoutveld is de meest waardevolle eigendom van de gemeente.
          Het Beverhoutsveld moet in handen blijven van de gemeente.{" "}
        </p>
        <p>
          Eigenaars moeten een rechtvaardige vergoeding krijgen bij onteigening.
        </p>
      </Page>
    );
  }
}

export default Grondbeleid;
